module.exports = __webpack_public_path__ + "static/media/1002947.cb8d0dad.png";